/**
 * Display-formatting helpers. EUR-first since the user is in Portugal.
 *
 * The backend returns Decimal-as-string for amounts; tolerate both string
 * and number to avoid NaN surprises in the UI.
 */

export function eur(value: string | number | null | undefined): string {
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  }).format(n);
}

export function money(
  value: string | number | null | undefined,
  currency: string,
  frac = 2,
): string {
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);
  if (Number.isNaN(n)) return '—';
  // Fall back to a plain number + ISO code for unknown / non-ISO currencies
  // (e.g. crypto tickers) — Intl will throw otherwise.
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currency.toUpperCase(),
      maximumFractionDigits: frac,
    }).format(n);
  } catch {
    return `${n.toFixed(frac)} ${currency.toUpperCase()}`;
  }
}

export function num(value: string | number | null | undefined, frac = 0): string {
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('en-IE', {
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  }).format(n);
}

export function pct(value: string | number | null | undefined, frac = 1): string {
  const n = typeof value === 'string' ? Number(value) : (value ?? 0);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('en-IE', {
    style: 'percent',
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  }).format(n);
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString('en-IE', {
    day: '2-digit',
    month: 'short',
  });
}
